import { toCamelCase } from '@vrplatform/utils';

export const formatManualReservationLineType = (lineName: string) => {
  const normalized = toCamelCase(lineName.trim());

  if (!normalized) return null;

  return `vrt_${normalized}`;
};
